import React from 'react';
import { Menu } from 'lucide-react';
import ShellAccountActions from '../../components/Header/ShellAccountActions';
import ThemeToggle from '../../components/GeneralComponents/ThemeToggle';
import './AppHeader.css';

export default function AppHeader({ drawerWidth, handleDrawerToggle, handlePermanentDrawer }) {
  return (
    <header
      className="app-header-nav"
      style={{
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
      }}
    >
      <div className="app-header-toolbar">
        {/* Mobile menu toggle */}
        <button
          className="xs-btn xs-btn-link text-reset d-sm-none p-0 border-0"
          onClick={handleDrawerToggle}
          aria-label="open drawer"
        >
          <Menu size={24} />
        </button>

        {/* Desktop menu toggle */}
        <button
          className="xs-btn xs-btn-link text-reset d-none d-sm-block p-0 border-0"
          onClick={handlePermanentDrawer}
          aria-label="toggle sidebar"
        >
          <Menu size={24} />
        </button>
      </div>

      <div className="d-flex gap-3 align-items-center">
        <ThemeToggle variant="header" />
        <ShellAccountActions />
      </div>
    </header>
  );
}
